$(function () {
  // Share modal
  $('article .button-share').on('click', function (e) {
    e.preventDefault();
    $('.share-modal-cover').fadeIn('fast');
    $('.share-modal-container').fadeIn('fast');
  });

  $('.share-modal-cover, .share-close, .close-modal-btn-wrapper').on('click', function (e) {
    $('.share-modal-cover').fadeOut('fast');
    $('.share-modal-container').fadeOut('fast');
  });

  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      $('.share-modal-cover').fadeOut('fast');
      $('.share-modal-container').fadeOut('fast');
    }
  });
});
